import useElement from "backend/hooks/elements/useElement";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useLink";
import React from "react";
import ToolbarWithHeading from "./ToolbarWithHeading";

const ToolbarWithMeasureName = () => {
  const ctx = useAppContext();
  const link = useLink();
  const { data, isLoading } = useElement(ctx.elementId);
  const metadata = data?.JS_ATTR ? JSON.parse(data?.JS_ATTR) : "";
  const measureName = metadata
    ? metadata["Localized-Text-Attributes"]?.[ctx.language]?.Name
    : data?.name;
  return <ToolbarWithHeading>{measureName ?? ""}</ToolbarWithHeading>;
};

export default ToolbarWithMeasureName;
